


































import { downloadDGNDDReportExcel } from '@/utils/ApiServices'
import { formatDateTime } from '@/utils/CommonUtils'
import { handle } from '@/utils/ErrorHandling'
import { RecentReport } from '@/utils/Interfaces'
import fileDownload from 'js-file-download'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class DGNDDBaoCaoGanDay extends Vue {
  @Prop() readonly loading!: boolean
  @Prop() readonly reports!: Array<RecentReport>

  download (id: RecentReport['id']) {
    downloadDGNDDReportExcel(id)
      .then(response => {
        const filename = response.headers['content-disposition'].split(';')[1].replace('filename=', '').trim()
        fileDownload(response.data, filename)
      })
      .catch(handle)
  }

  getCreateDate (date: RecentReport['created_at']) {
    const createDate = (new Date(date)).getTime()
    const now = (new Date).getTime()
    const timeDiff = (now - createDate) / 1000  // Convert miliseconds to seconds
    if (timeDiff < 1 * 60) {
      return 'Vừa xong'
    }
    else if (timeDiff < 2 * 60) {
      return '1 phút trước'
    }
    else if (timeDiff < 3 * 60) {
      return '2 phút trước'
    }
    else if (timeDiff < 4 * 60) {
      return '3 phút trước'
    }
    else if (timeDiff < 5 * 60) {
      return '4 phút trước'
    }
    else if (timeDiff < 6 * 60) {
      return '5 phút trước'
    }
    else {
      return formatDateTime(date)
    }
  }

  page = 1
  pageSize = 5

  get paginatedReports () {
    const startIndex = (this.page - 1) * this.pageSize
    const endIndex = startIndex + this.pageSize
    const paginatedReports = this.reports.slice(startIndex, endIndex)
    return paginatedReports
  }

  get pagesLength () {
    return Math.ceil(this.reports.length / this.pageSize)
  }

  get showPagination () {
    return this.reports.length > this.pageSize
  }
}
